var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.235 8.002.152 15.133a.51.51 0 0 0 0 .718.497.497 0 0 0 .712 0l7.135-7.185 7.137 7.185a.498.498 0 0 0 .712 0 .51.51 0 0 0 0-.718l-7.082-7.13L15.853.864a.51.51 0 0 0 0-.717.501.501 0 0 0-.712 0L8 7.338.859.149a.5.5 0 0 0-.712 0 .51.51 0 0 0 0 .717l7.088 7.137z",
    fill: "#282828",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.0f4de990c53ee90308d37f8fdc3c5908.svg";
export { ForwardRef as ReactComponent };